import config from '../../config/app'
import axios from 'axios'

// const nameSpace = 'admin/'

const usersAPI = {
  impersonate (userId) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/impersonate/' + userId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}

export default usersAPI



// WEBPACK FOOTER //
// ./src/api/admin/users.js